import { useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useStoreActions } from '../../store';
import { applyThemeColors } from '../../utils/iframe/applyThemeColors';
import { parseUrlContext } from '../../utils/iframe/parseUrlContext';

const UrlContextSync = () => {
  const location = useLocation();
  const setContext = useStoreActions(actions => actions.orgContext.setContext);

  useLayoutEffect(() => {
    const partial = parseUrlContext(location.search);
    if (Object.keys(partial).length === 0) {
      return;
    }

    setContext(partial);
    applyThemeColors(partial.primaryColor, partial.textColorOverride);
  }, [location.search, setContext]);

  return null;
};

export default UrlContextSync;
